



































































import Vue from 'vue';
import moment from 'moment-timezone';
import _ from 'lodash';

import Requester from '../../requester';

import { ConsultaColetiva } from '../../../../back/src/entity/ConsultaColetiva';
import { TipoConsultaColetiva, ConsultaColetivaCancelarFormData } from '../../../../back/src/types';

import CustomDialog from '../CustomDialog.vue';

export default Vue.extend({
  name: 'ConsultaColetivaCancelarDialog',
  props: {
    statusConsultaColetiva: {
    },
    consultaColetiva: Object as () => ConsultaColetiva,
  },
  components: {
    CustomDialog,
  },
  data() {
    return {
      tipos: TipoConsultaColetiva,
      dialog: false,
      loading: false,
      form: {
        justificativa_cancelamento: '',
      },
      rules: {
        required: [
          (v: string) => !!v || 'Campo obrigatório',
        ],
      },
    };
  },
  computed: {
    formCancelaConsultaColetiva(): Vue & { validate: () => boolean, resetValidation: () => void } {
      return this.$refs.formCancelaConsultaColetiva as Vue & {
        validate: () => boolean,
        resetValidation: () => void
      };
    },
    dataInicio() {
      return moment(this.consultaColetiva.datetime_agendamento).format('DD/MM/YYYY');
    },
    dataFim() {
      return moment(this.consultaColetiva.datetime_agendamento_fim).format('DD/MM/YYYY');
    },
    horaInicio() {
      return moment(this.consultaColetiva.datetime_agendamento).format('HH:mm');
    },
    horaFim() {
      return moment(this.consultaColetiva.datetime_agendamento_fim).format('HH:mm');
    },
    inicioFimMesmoDia() {
      return this.dataInicio === this.dataFim;
    },
  },
  methods: {
    close() {
      this.formCancelaConsultaColetiva.resetValidation();
      this.dialog = false;
    },
    // eslint-disable-next-line func-names
    submitFormDebounce: _.debounce(async function () { await this.submitForm(); }, 200),
    async submitForm() {
      this.loading = true;
      if (!this.formCancelaConsultaColetiva.validate()) {
        this.loading = false;
        return;
      }
      const formData: ConsultaColetivaCancelarFormData = {
        id: this.consultaColetiva.id,
        justificativa_cancelamento: this.form.justificativa_cancelamento,
      };
      try {
        const response = await Requester.consultaColetiva.cancelaConsultaColetiva(formData);
        if (response.errors.length > 0) {
          this.$root.$emit('avisoSnackbar', { color: 'error', text: response.errors });
        } else {
          this.form.justificativa_cancelamento = '';
          this.close();
          this.$emit('recarrega-consultas-coletivas');
          this.$root.$emit('avisoSnackbar', { color: 'success', text: 'Consulta coletiva cancelada com sucesso!' });
        }
      } catch (err) {
        this.$root.$emit('requestError', err);
      } finally {
        this.loading = false;
      }
    },
  },
});
